import React from 'react';

/**
 * Rend le Markdown minimal du chat : paires **…** → <strong>…</strong>.
 * Le reste du texte est affiché tel quel (pas d’HTML arbitraire).
 */
export function renderInlineBoldMd(text: string): React.ReactNode {
    if (text == null || text === '') return text;
    const out: React.ReactNode[] = [];
    let last = 0;
    const re = /\*\*([^*]+)\*\*/g;
    let m: RegExpExecArray | null = re.exec(text);
    let key = 0;
    while (m !== null) {
        if (m.index > last) {
            out.push(<React.Fragment key={`t${key++}`}>{text.slice(last, m.index)}</React.Fragment>);
        }
        out.push(<strong key={`b${key++}`}>{m[1]}</strong>);
        last = re.lastIndex;
        m = re.exec(text);
    }
    if (last < text.length) {
        out.push(<React.Fragment key={`t${key++}`}>{text.slice(last)}</React.Fragment>);
    }
    return out.length === 0 ? text : <>{out}</>;
}
